// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"a33befcd","234":"10fcbbd8","344":"3aff92c7","359":"7288b866","361":"b056646d","629":"d77bc8ce","809":"f86d25c7","918":"fa46590a"}[chunkId] + ".chunk.js";
};